(function () {

  /**
   *  Initialize the save/unsaved buttons displayed in the next steps redesigned section
   */
  var initSaveToFavorites = function () {
    var nextStepsSaveButton = document.querySelector("[data-favorites-save]");
    var gallerySaveButton = document.querySelector("#gallery .nhs_favUnsave");
    var saveToFavoritesLoginButton = document.querySelector("#gallery .nhs_favLogin");
    if (nextStepsSaveButton !== null) {
      nextStepsSaveButton.addEventListener("click", function () {
        if (saveToFavoritesLoginButton && !saveToFavoritesLoginButton.classList.contains("nhs_favLogin")) {
          saveToFavoritesLoginButton.click();
        } else if (!gallerySaveButton.classList.contains("nhs_favLogin")) {
          gallerySaveButton.click();
        }

      });
    }
    var nextStepsUnsaveButton = document.querySelector("[data-favorites-unsave]");
    var galleryUnsaveButton = document.querySelector("#gallery .nhs_favSaved");
    if (nextStepsUnsaveButton !== null) {
      nextStepsUnsaveButton.addEventListener("click", function () {
        galleryUnsaveButton.click();
      });
    }
  }

  //Events to Track Google Analytics, uses the ga function declared globally by Analytics.js
  var bindGoogleAnalyticsEvents = function () {
    document.addEventListener("click", function (event) {
      var eventCategory = "Gallery Detail Pages";
      var eventAction = null;
      var id = null;
      var eventLabel = null;

      if (!event.target || "function" !== typeof ga || (ga && "function" !== typeof ga.getAll)) {
        return;
      }

      var allGa = ga.getAll().filter(function (element) {
        return element.get("trackingId") === "UA-40843711-4";
      });

      if (allGa[0]) {
        id = allGa[0].get("name");
      }

      if (event.target.classList.value === "media-tabs__icon") {
        event.target.id = event.target.parentElement.id;
      }

      if ("img" === event.target.nodeName.toLowerCase() && event.target.getAttribute('data-full-image-viewer-opener') === 'true' && event.target.classList && event.target.classList.contains("active")) {
        eventAction = "FWIV open - image click";
        eventLabel = "Image click to open FWIV";
      }

      if ("nhs_GalleryPrev" === event.target.id) {
        eventAction = "On-page Gallery forward-back";
        eventLabel = "Back";
      }

      if ("nhs_GalleryNext" === event.target.id) {
        eventAction = "On-page Gallery forward-back";
        eventLabel = "Forward";
      }

      if (event.target.classList.contains("nhs_Close")) {
        eventAction = "Gallery Navigation";
        eventLabel = "Close button clicks";
      }

      //Additional Details Label
      if ("nhs_additionalDetailsLabel" === event.target.id) {
        eventCategory = "Detail Page Events";
        eventAction = "Clicks to additional com details";
        eventLabel = "Additional com details";
      }

      //Add to NHS App - From Map
      if ("nhs_addToNhsAppOnMap" === event.target.id) {
        eventCategory = "Detail Page Events";
        eventAction = "Misc Click Events";
        eventLabel = "Add to NHS App - from map area";
      }

      //Tabs on Map Section
      if ("object" === typeof event.target.dataset && event.target.dataset.isMapDirectionsTab) {
        var tabsElements = document.querySelectorAll("[data-is-map-directions-tab]");
        if (tabsElements && tabsElements.length > 1) {
          eventCategory = "Detail Page Events";
          eventAction = "Insert Map Navigation";
          eventLabel = "Tab click - " + event.target.textContent;
        }
      }

      //Inset map - Map Section
      if ("nhs_PropertyMapImage" === event.target.id) {
        eventCategory = "Detail Page Events";
        eventAction = "Inset Map Navigation";
        eventLabel = "Clicks map to make interactive";
      }

      //View Builder Driving Directions
      if ("nhs_viewDrivingDirections" === event.target.id) {
        eventCategory = "Detail Page Events";
        eventAction = "Driving Directions Views";
        eventLabel = "Clicks to see driving directions";
      }

      //Route widget
      if ("object" === typeof event.target.dataset && event.target.dataset.showMapDirections) {
        eventCategory = "Detail Page Events";
        eventAction = "Routes Generated";
        eventLabel = "Route generated";
      }

      //Add Link for Commute Calculator
      if ("nhs_mapAddRoute" === event.target.id) {
        eventCategory = "Detail Page Events";
        eventAction = "Commute Calc Events";
        eventLabel = "Adds additional commute destination";
      }

      //Commute Calculator
      if ("nhs_calculateCommute" === event.target.id) {
        eventCategory = "Detail Page Events";
        eventAction = "Commute Calc Events";
        eventLabel = "Commute time generated";
        var travelModeElement = document.querySelector("[data-travel-mode].active");

        if (travelModeElement &&
          "object" === typeof travelModeElement.dataset &&
          travelModeElement.dataset.travelMode) {
          eventLabel += " - " + travelModeElement.dataset.travelMode.toLowerCase();
        } else { //By Default is driving
          eventLabel += " - driving";
        }
      }

      if (eventAction && eventLabel && id && window.ga) {
        ga(id + ".send", "event", eventCategory, eventAction, eventLabel);
      }
    });
  }

  var phone = document.querySelector("#TrackingPhoneNumber").value;
  var container = document.querySelector("#nhs_DetailSalesOffice [data-slider-component]") ||
    document.querySelector("[data-slider-component]");
  initDatePicker(container, phone, "/");
  initSaveToFavorites();
  bindGoogleAnalyticsEvents();

  var loadEmailSuggestions = function (event) {
    if (!window.Mailcheck && typeof NHS.loadJs === "function") {
      NHS.loadJs(document.getElementById("CtaDependencies").value);
    } else if (window.NewHomeSource && window.NewHomeSource.EmailDomainValidator) {
      window.NewHomeSource.EmailDomainValidator();
    }
    this.removeEventListener("focusin", loadEmailSuggestions);
  }

  function showPhoneNumber(hideSection, displaySection) {
    var hidePhones = document.querySelectorAll(hideSection);
    var showPhones = document.querySelectorAll(displaySection);
    if (hidePhones.length === 0 || showPhones.length === 0) {
      return;
    }
    hidePhones.forEach(element => element.setAttribute('hidden', ''));
    showPhones.forEach(element => element.style.display = 'block');
    jQuery.SetDataLayerPair("sitePhoneNumV");
  }

  function showPhone(event) {
    if (event.target.closest('[data-phone-reveal-text]')) {
      showPhoneNumber("[data-phone-reveal-text]", "[data-phone-reveal-number]");
    }
  }

  document.body.addEventListener('click', showPhone);
  var onPageForm = document.querySelector("[data-onpage-form]");
  onPageForm.addEventListener("focusin", loadEmailSuggestions);
})();

(function () {
  /*
  *  This intersectionObserver is used to get the viewport of the sections of the details
  */
  var options = {
    rootMargin: '10px',
    threshold: 0.05
  }

  const headerHeight = 180;

  var observerMainStickyBar = function () {
  var sectionDetails = document.querySelector("[data-details-container]");
  var sectionsToObserve = null;
  var userHeight = window.innerHeight;

  var observer = new IntersectionObserver(function (entries) {
    requestAnimationFrame(calculateSection);
  }, options);

    /**
     * calculateSection : method to check what is the section that is visible on the viewport to fix issues with scroll animation
     *
     */
    function calculateSection() {
      setTimeout(function () {
        var mainEntry = null;

        for (var i = 0; i < sectionsToObserve.length; i++) {
          var topSection = sectionsToObserve[i].getBoundingClientRect().top;
          if (topSection > headerHeight) {
            if (topSection > userHeight) {
              mainEntry = sectionsToObserve[i - 1];
            } else {
              mainEntry = sectionsToObserve[i];
            }
            break;
          }
        }
        if (mainEntry) {
          var stickyBar = document.querySelector("[data-sticky-nav-bar]");
          const activeElement = stickyBar.querySelector("[data-item-active]");
          if (stickyBar && activeElement) {
            delete activeElement.dataset.itemActive;
            activeElement.classList.remove("nhs-n1-c-button--nav-light-active");
          }
          var entry = document.querySelector("a[data-id=\"" + mainEntry.id + "\"]");
          if (entry) {
            entry.dataset.itemActive = 'true';
            entry.classList.add("nhs-n1-c-button--nav-light-active");
            requestAnimationFrame(window.NewHomeSource.Modules.stickyBarScrollHandler.moveStickyBarScroll.bind(null, entry, '[data-scroll]'));
          }
        }
      },
        200);
    }

    /*
     *  Track all sections that have an `id` applied
     */

    if (sectionDetails) {
      sectionsToObserve = sectionDetails.querySelectorAll("[data-detail-section]");
    }

    if (sectionsToObserve) {
      for (var sectionIndex = 0; sectionIndex < sectionsToObserve.length; sectionIndex++) {
        observer.observe(sectionsToObserve[sectionIndex]);
      }
    }
  }
  observerMainStickyBar();
})();